import { VideoStatesInterface } from "../types/VideoPlayerInterface";
import { DescriptionStatesInterface } from "../types/DescriptionStatesInterface";

export const videoStates: VideoStatesInterface = {
  LOADING: "LOADING",
  READY: "READY",
  PLAYING: "PLAYING",
  ENDED: "ENDED",
};

export const descriptionStates: DescriptionStatesInterface = {
  SHOW: "SHOW",
  HIDE: "HIDE",
};
